/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { Checkbox } from '@fluentui/react/lib/Checkbox';
import { Stack } from '@fluentui/react/lib/Stack';
import * as React from 'react';
import { Badge } from 'src/core/components/Badge';
import { useLocalization } from 'src/core/hooks/useLocalization';
import { getTranslatedEntityType } from 'src/luis/modules/entities/utils/translatedEntityType';
import { FiltersItem, SelectionChange } from 'src/verticals/utterancesFilters/types/Filters';

type FilterItemWithCheckboxProps = {
    /*
     * The items used for filtration
     */
    item: FiltersItem;

    /**
     * Handler function for item selection
     */
    onSelectionChange: (change: SelectionChange) => void;
};

export const FilterItemWithCheckbox = React.memo((props: FilterItemWithCheckboxProps) => {
    const { item, onSelectionChange } = props;
    const { localize } = useLocalization();

    return (
        <Checkbox
            label={item.name}
            onRenderLabel={(checkboxProps, defaultRender) => (item.filterType === 'entities' ? (
                    <Stack horizontal verticalAlign="center" tokens={{ childrenGap: 8 }}>
                        {defaultRender(checkboxProps)}
                        <Badge text={getTranslatedEntityType(item.filterType.entityType, localize)} />
                    </Stack>
                ) : (
                    defaultRender(checkboxProps)
                ))
            }
            checked={item.isChecked}
            onChange={() => onSelectionChange({ changeType: item.filterType, args: item })}
        />
    );
});
